// Default content for the site - used as fallback if DB section missing
import heroImg from "@/assets/hero-gemara.jpg";
import beitMidrashImg from "@/assets/beit-midrash.jpg";
import rabbiImg from "@/assets/rabbi.jpg";


export const DEFAULT_CONTENT: Record<string, any> = {
  home: {
    heroTitle: "ישיבת תורת חיים",
    heroSubtitle: "התורה היא החיים של כולנו",
    heroCta: "להרשמה",
    heroImage: heroImg,
    aboutTitle: "אודותינו",
    aboutSubtitle: "אבני חינוך - מוסדות תורת חיים בסיפור של חינוך מלוטש",
    aboutText: "המסגרת הוקמה במטרה לתת מענה לנערים יראי שמיים בעלי מידות טובות, השואפים לגדולות. נערים אשר טרם עלה בידם למצות את כוחותיהם ויכולותיהם ולהגשים את שאיפותיהם במסגרת תלמודי התורה שבהם שהו, ונזקקו למסגרת ייחודית ומותאמת יותר.\n\nברבות השנים עלה צורך נוסף; לתת מענה גם לבחורים שכבר השתלבו בעולם הישיבות הקטנות, אך קשייהם, שלא קיבלו מענה בתלמוד תורה, יצרו פער משמעותי בהתפתחותם הלימודית והרגשית.",
    aboutImage: beitMidrashImg,
    rabbiTitle: "דבר ראש הישיבה",
    rabbiText: "הלך עבר בין גינות המושב, והנה הוא רואה אדם משקה עץ יבש וקמל.\n\n\"מדוע אתה מבזבז מים על עץ זה? אין לו סיכוי לפרוח!\". האדם חייך חיוך מלא תקווה, נשא עיניו לשמיים וענה בביטחון, \"אתה רואה את העץ שעומד כאן. אני רואה בדמיוני את העץ שעתיד להיות כאן בעוד תקופה, רואה כבר את עליו הרעננים, מריח את פריחתו, טועם את פירותיו המתוקים\".\n\nבתוך גינתנו יש מגוון תלמידים. אנו יודעים כי בעזרת השקיה מתונה ומתאימה, מילות עידוד והעצמה, קשר קרוב עם דמויות סמכות וחיזוק הדימוי העצמי – הוא עתיד לגדול לתפארת עולם התורה.\n\nאנחנו, כבר כעת, רואים מול עינינו את עצי העתיד הללו, משקים ומשקיעים בגידולם.",
    rabbiImage: rabbiImg,

  },
  about: {
    title: "אודותינו",
    subtitle: "מוסדות תורת חיים",
    coverImage: "",
    paragraphs: [
      "המסגרת הוקמה במטרה לתת מענה לנערים יראי שמיים בעלי מידות טובות, השואפים לגדולות. נערים אשר טרם עלה בידם למצות את כוחותיהם ויכולותיהם ולהגשים את שאיפותיהם במסגרת תלמודי התורה שבהם שהו.",
      "ברבות השנים עלה צורך נוסף; לתת מענה גם לבחורים שכבר השתלבו בעולם הישיבות הקטנות, אך קשייהם, שלא קיבלו מענה בתלמוד תורה, יצרו פער משמעותי בהתפתחותם הלימודית והרגשית.",
      "ב\"תורת חיים\" נזהה, מהשלב הראשון, את נקודות הקושי עליהן יש לעמול, נקבע תוכנית אישית מותאמת לתלמיד שתבנה את אישיותו, וזו תלווה אותו לאורך כל תקופת לימודו במסגרת עד לשילובו בישיבה קטנה/גדולה טובה ומתאימה, עם כל הכלים הנדרשים להצלחתו.",
    ],
    forWhomTitle: "למי אנחנו?",
    forWhomText: "השאלה הראשונה שלי בראיון לתלמיד היא, \"למה הגעת לכאן?\". כשהתלמיד עונה לי, \"כדי להצליח ולצמוח בתורה\", אני יודע שהוא יכול להתאים! (ראש הישיבה)",
    pathTitle: "לאורך נלך",
    pathText: "הדרך שלנו משלבת לימוד תורה ברמה גבוהה, יחס אישי לכל תלמיד, בניית אישיות, חיזוק הביטחון העצמי וטיפוח מידות תרומיות - הכל בסביבה תומכת ומקבלת.",
    journeyTitle: "הדרך שלנו",
    journeySubtitle: "ששה צעדים של צמיחה",
    journey: [
      { title: "זיהוי", text: "תהליך ההרשמה למכינה ולישיבה מלווה במבחנים ייעודיים לזיהוי מפת החוזקות והקשיים של התלמיד, כדי שיוכל לקבל בהקדם את הכלים לצמיחה האישית שלו." },
      { title: "סיפוק ומוטיבציה", text: "תהליך הלמידה מותאם לרמת התלמידים, ובנוי בצורה המאפשרת לתלמידים להגיע להישגים לימודיים, ובכך הם מקבלים מוטיבציה להמשיך להשקיע בעצמם." },
      { title: "ערך עצמי", text: "במהלך השנה התלמידים משתתפים בסדנאות קבוצתיות ופרטניות, הממקדות אותם בתוכנית האישית שלהם לצמיחה, למודעות, ולפיתוח זהות והערכה עצמית." },
      { title: "בניית האישיות", text: "אנו משתמשים בכל הכלים, כדי לעזור לכל תלמיד לפרוץ את המחסום האישי שלו, ולבנות אישיות בעלת אחריות ובעלת חשיבה עצמאית, בהשקפה תורנית." },
      { title: "הווי, חיבור וזהות", text: "במהלך השנה מתקיימות שבתות גיבוש, ימי שדה, טיולים, פעילויות וחידונים, כדי לחבר את התלמיד ולתת לו תחושת שייכות לזהות הישיבתית והתורנית שנבנית אצלו בהדרגה ומתחזקת בעקביות." },
      { title: "הצלחה", text: "רובם המכריע של בוגרי המכינה והישיבה מפארים את היכלי הישיבות הגדולות, ומקימים בית תורני המושתת על יסודות איתנים, לאחר שעברו את גיל הבחרות עם יד מכוונת ובונה." },
    ],
  },
  programs: {
    title: "ארגז הכלים",
    subtitle: "המענים הייחודיים של תורת חיים",
    coverImage: "",
    items: [
      { title: "תפילה", text: "הרבה הרבה תפילות ללא הפסקה לסייעתא דשמיא להצלחת כל תלמיד ותלמיד בדרכו שלו." },
      { title: "אמונה", text: "להאמין בכוחו של כל תלמיד להצליח בלימוד התורה הקדושה." },
      { title: "השתדלות", text: "אנו מפעילים את כל הכלים שברשותנו להצלחת התלמידים." },
      { title: "הצוות החינוכי", text: "במכינה ובישיבה צוות מחנכים ורמי\"ם ערכי, תורני ומקצועי, בעלי הכשרה מתאימה, חדורי תחושת שליחות, להצמיח מכל תלמיד אישיות בנויה לחיים." },
      { title: "צוות רב-מערכתי", text: "במקביל לצוות ההוראה פועל צוות המעניק סיוע רגשי אישי וקבוצתי על ידי מטפלים באומנות, מוסיקה, קלינאי תקשורת, ריפוי בעיסוק, עו\"ס, ובמקרה הצורך גם ייעוץ רפואי." },
      { title: "כולם למען אחד", text: "ניתנת חשיבות רבה לעבודה מערכתית הכוללת תיאום ושילוב כל הצוות החינוכי והטיפולי בבנייה וביישום של תוכנית קידום לכל תלמיד ותלמיד." },
      { title: "קבוצות קטנות", text: "הכיתות מכילות 8-12 תלמידים כדי למקסם את תשומת הלב של הרב לכל תלמיד באופן אישי. הרב נעזר גם בסייע. הכיתות מסווגות לפי רמת התלמידים ואפיון היכולות שלהם." },
      { title: "הוראה מותאמת אישית", text: "רמת הלמידה וההספקים נקבעת בהתאם ליכולות התלמידים, כך גם אמצעי ההוראה והמבחנים, הכול כדי לקדם תלמיד, לתת לו מיומנויות והרגלי למידה, ולהעניק לו חוויית הצלחה. התלמידים נעזרים גם בהוראה פרטנית של חונכים." },
      { title: "תוכנית עבודה פרטנית", text: "עם תחילת שנת הלימודים נבנית תוכנית קידום אישית לכל תלמיד שמקיפה את התחום הלימודי, החברתי והרגשי, בשיתוף היועץ החינוכי, הצוות הטיפולי, התלמיד וההורים. התוכנית כוללת מטרות ויעדים הנבדקים ומתעדכנים במהלך השנה." },
      { title: "עידוד ותמריצים", text: "נעשה שימוש מוגבר בחיזוקים על ידי פרסי עידוד, טיולים ויציאות הגורמים לתלמידים להתאמץ ולשמוח בהצלחתם. כמו כן התלמידים משולבים מדי יום ביומו בפעילות חוגים המאפשרת להם להתאוורר ולמלא מצברים להמשך הלמידה." },
      { title: "שיח פרטני וקבוצתי", text: "עבודה מקצועית חדשנית וממוקדת בבניית העולם הרגשי והערכי של התלמידים, באמצעות תוכניות ייעודיות המשפרות את השיח הרגשי, הבקרה והוויסות של התלמידים." },
      { title: "שיתוף פעולה עם ההורים", text: "קשר רציף ועקבי עם ההורים, שיתוף בתהליכים ובהחלטות, וליווי משותף של כל תלמיד לאורך הדרך." },
    ],
    scheduleTitle: "סדר יום",
    scheduleSubtitle: "מסגרת ברורה ומחבקת — לשני הסניפים",
    schedules: [
      {
        branch: "מכינת תורת חיים",
        tagline: "סדר יום מאוזן המשלב לימוד, חוגים ומקצועות חול",
        items: [
          { time: "08:00", label: "תפילת שחרית – תפילין וברכות" },
          { time: "08:10", label: "תפילת שחרית – \"הודו\"" },
          { time: "09:10", label: "ארוחת בוקר" },
          { time: "09:30", label: "שיעור גמרא עיון" },
          { time: "10:30", label: "הפסקה" },
          { time: "11:00", label: "שיעור חזרה וסיכום הגמרא עיון" },
          { time: "11:50", label: "הפסקה" },
          { time: "12:20", label: "שיעור \"פוסק הדור\"" },
          { time: "13:00", label: "ארוחת צהריים בחדר האוכל" },
          { time: "13:30", label: "שיעור משנה / אחר" },
          { time: "14:15", label: "הפסקה" },
          { time: "14:45", label: "מקצועות חול" },
          { time: "15:30", label: "הפסקה" },
          { time: "16:00", label: "חוג ראשון" },
          { time: "16:45", label: "חוג שני" },
          { time: "17:30", label: "ימים ב'-ד': נביא | ימים א',ה': שיחה מראש הישיבה" },
          { time: "18:00", label: "תפילת מנחה" },
        ],
        note: "רשימת חוגים: נגרות, כלכלת בית, טאקוונדו, אלקטרוניקה, כדורגל, סנוקר, קואורדינציה, גיטרה, פיסול, דרמה.",
      },
      {
        branch: "ישיבת מנחת יהודה",
        tagline: "\"והגית בו יומם ולילה\" — סדר יום ישיבתי מלא",
        items: [
          { time: "08:00", label: "תפילת שחרית – תפילין וברכות" },
          { time: "08:10", label: "תפילת שחרית – \"הודו\" (בסיומה \"שתי הלכות\")" },
          { time: "09:10", label: "ארוחת בוקר" },
          { time: "09:30", label: "שיעור גמרא עיון" },
          { time: "10:55", label: "סדר א'" },
          { time: "11:25", label: "הפסקה" },
          { time: "11:45", label: "שיעור חזרה וסיכום הגמרא עיון" },
          { time: "12:20", label: "הפסקה" },
          { time: "12:40", label: "שיעור משנה / שיעור כללי" },
          { time: "13:10", label: "שיעור הכנה לתפילה" },
          { time: "13:15", label: "תפילת מנחה" },
          { time: "13:30", label: "הפסקת צהריים, ארוחה, מנוחה וחוגים (לפנימייה)" },
          { time: "15:45", label: "שיעור גמרא בקיאות" },
          { time: "16:50", label: "הפסקה" },
          { time: "17:10", label: "סדר ב'" },
          { time: "17:40", label: "הפסקה" },
          { time: "18:00", label: "ימים א',ד': הלכה ונביא | ב': סמב\"ת | ג',ה': חומש ומוסר" },
          { time: "19:00", label: "ארוחת ערב" },
          { time: "19:30", label: "סדר ג' – סדר הכנה (יום ה': שיחה מוסרית)" },
          { time: "20:15", label: "תפילת ערבית" },
        ],
        note: "הקו המנחה: לימוד תורה כערך עליון, מעטפת רוחנית, זמני אוורור והווי חינוכי.",
      },
    ],

  },
  support: {
    title: "טיפולים ומענים רגשיים",
    subtitle: "מענה מותאם לכל תלמיד",
    coverImage: "",
    intro: "כאן כל תלמיד, בכל שלב – מתאמץ ועובד קשה, כדי להגיע ליותר. מכל נקודה בה הוא נמצא, נדרבן אותו להגיע ליותר.",
    areas: [
      {
        title: "לקויות למידה",
        text: "לקות למידה היא מצב נוירולוגי המשפיע על יכולתו של אדם לעבד ולהבין מידע, אף שיש לו אינטליגנציה ממוצעת או מעל הממוצע. ליקויי למידה יכולים להתבטא בקושי בקריאה, כתיבה, דיבור או חישובים מתמטיים, ולפעמים גם ביכולת לארגן, לזכור ולהשלים משימות.\n\nלרוב ילדים לקויי למידה צוברים פערים לימודיים, חווים פגיעה בדימוי העצמי, ופעמים רבות חשים מתוסכלים ולא מוצלחים. בתורת חיים תלמידים אלה חווים הצלחה, ולומדים להאמין בעצמם שהם מסוגלים לגדול תלמידי חכמים.",
      },
      {
        title: "קשיי קשב וריכוז",
        text: "ההפרעה כוללת ארבעה מאפיינים עיקריים: קושי בריכוז, קושי בקשב ותזמון, היפראקטיביות ואימפולסיביות. גם מי שיש לו רק חלק ממאפיינים אלו נחשב לעיתים כסובל מהפרעת קשב.\n\nכאשר הילד צבר פערים לימודיים וספג חוויות שליליות, המענה נמצא לעיתים קרובות בתורת חיים. לישיבה ניסיון אדיר ומצטבר של הצלחה עם ילדים החווים קשיי קשב וריכוז.",
      },
      {
        title: "קושי רגשי",
        text: "קושי רגשי ברמה גבוהה מקשה על הילד בשגרה, והדבר מתבטא גם בלימוד בכיתה. ילד שזמן רב חווה חוסר הצלחה וכישלונות, מרגיש את עצמו כשלילי ובעייתי, והדימוי העצמי שלו נפגע קשות.\n\nיש ילדים הסובלים מפחדים, חרדות ונדודי שינה, לעיתים בעקבות התמודדות משפחתית או רפואית. מעבר למענה הלימודי המקצועי, התלמיד מקבל מעטפת מושלמת לצרכיו הרגשיים.",
      },
    ],
    signsTitle: "סימני אזהרה אצל ילדכם?",
    signs: [
      "לא רוצה ללכת לתלמוד תורה",
      "מאחר פעמים רבות באופן מוגזם",
      "ללא מוטיבציה ללמידה",
      "נראה \"כבוי\"",
      "כועס ומתמרמר",
    ],
    signsFooter: "במקרים אלו יש לבדוק את הסיבות להתנהגויות ולתת להם מענה באמצעות אבחון פסיכולוגי, הדרכת הורים, חונך או מטפל רגשי.",
    notFitTitle: "מי לא מתאים לתורת חיים?",
    notFit: [
      "תלמיד שיכול למצות את עצמו במסגרת שבה הוא לומד",
      "תלמיד בעל קושי רוחני",
      "תלמיד שהוא או משפחתו אינם בשאיפה שיצמח (וייראה) כבחור ישיבה",
      "תלמיד בעל רמת משכל נמוכה",
      "תלמיד המוגדר כבעל הפרעות התנהגות",
      "תלמיד בעל התמודדות נפשית",
      "מי שרוצה חיים קלים, בלי מאמץ, אינו מוצא כאן את מקומו",
    ],
  },
  registration: {
    title: "הרשמה",
    subtitle: "תהליך ההרשמה לישיבה",
    phone: "03-6761114",
    address: "רח' קהילות יעקב 61",
    steps: [
      {
        title: "קבעו פגישה",
        text: "חושבים שהתלמיד מתאים לתורת חיים? התקשרו למשרד בטלפון 03-6761114 לתיאום פגישה.",
      },
      {
        title: "מהלך הפגישה",
        text: "לפגישה מגיעים ההורים והתלמיד יחד עם כל החומר הרלוונטי המצוי בידי ההורים כדי שנוכל להתרשם ממנו ולבדוק התאמה. הפגישה מתבצעת בחדר ראש הישיבה, רח' קהילות יעקב 61.",
      },
      {
        title: "קבלת תשובה",
        text: "לאחר התרשמות וקבלת אינפורמציה מהמסגרת החינוכית שבה לומד התלמיד, תישלח התשובה. התשובה תינתן על ידי צוות המשרד.",
      },
      {
        title: "ברוך הבא!",
        text: "כעת התלמיד משובץ בתורת חיים ונשמח לראות אותו פורח ומתקדם אצלנו!",
      },
    ],
  },
};
